import React, { useState } from "react";
import { errorToast, successToast } from "../notifications/toast";
import { useDispatch } from "react-redux";
import { resetPasswordsAction } from "../../redux/actions/settingsAction";

const PasswordResetModal = ({ isOpen, onClose, resetingEmail }) => {
    const dispatch = useDispatch()
    const [currentPassword, setCurrentPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);

    const handlePasswordReset = () => {
        if (newPassword !== confirmPassword) {
            errorToast("New password and confirm password are not matching")
            return;
        }
        dispatch(resetPasswordsAction({ current_password: currentPassword, new_password: newPassword }, onSuccess, onError))

    };

    const onSuccess = (data) => {
        successToast(data.data.message);
        onClose();
    }

    const onError = (data) => {
        const errorMsg = data.data.message || "Unable to fetch try later";
        errorToast(errorMsg)
    }

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
            <div className="bg-white p-6 rounded-md shadow-lg w-full max-w-md">
                <h2 className="text-xl font-bold mb-2">Reset Password</h2>
                <p className="text-red-500 mb-2">Email: {resetingEmail}</p>
                <div className="mb-4">
                    <label
                        htmlFor="currentPassword"
                        className="block font-normal mb-2 text-start"
                    >
                        Current Password
                    </label>
                    <input
                        type={showPassword ? "text" : "password"}
                        id="currentPassword"
                        className="w-full px-4 py-2 border rounded-md input-field"
                        value={currentPassword}
                        onChange={(e) => setCurrentPassword(e.target.value)}
                    />
                </div>

                <div className="mb-4">
                    <label
                        htmlFor="newPassword"
                        className="block font-normal mb-2 text-start"
                    >
                        New Password
                    </label>
                    <input
                        type={showPassword ? "text" : "password"}
                        id="newPassword"
                        className="w-full px-4 py-2 border rounded-md input-field"
                        value={newPassword}
                        onChange={(e) => setNewPassword(e.target.value)}
                    />
                </div>

                <div className="mb-4">
                    <label
                        htmlFor="confirmPassword"
                        className="block font-normal mb-2 text-start"
                    >
                        Confirm New Password
                    </label>
                    <input
                        type={showPassword ? "text" : "password"}
                        id="confirmPassword"
                        className="w-full px-4 py-2 border rounded-md input-field"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                    />
                </div>

                <div className="flex items-center justify-between mb-4">
                    <div className="flex items-center">
                        <input
                            type="checkbox"
                            id="showPassword"
                            checked={showPassword}
                            onChange={() => setShowPassword(!showPassword)}
                        />
                        <label
                            htmlFor="showPassword"
                            className="ml-2 text-sm"
                        >
                            Show Passwords
                        </label>
                    </div>
                </div>

                <div className="flex justify-end gap-4">
                    <button
                        type="button"
                        onClick={onClose}
                        className="bg-gray-400 text-white px-4 py-2 rounded-md hover:bg-gray-500"
                    >
                        Cancel
                    </button>
                    <button
                        type="button"
                        onClick={handlePasswordReset}
                        className="bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600"
                    >
                        Reset Password
                    </button>
                </div>
            </div>
        </div>
    );
};

export default PasswordResetModal;
